import React from 'react';
import { useTranslation } from 'react-i18next';
import API from '../api';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = async (lang) => {
    await i18n.changeLanguage(lang);
    localStorage.setItem('language', lang);
    const userId = localStorage.getItem('userId');
    if (userId) {
      try {
        await API.put(`/users/${userId}/language`, { language: lang });
      } catch (e) {
        // non bloccante
      }
    }
  };

  const current = i18n.language;

  const btnStyle = (lang) => ({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: current === lang ? 'bold' : 'normal',
    color: current === lang ? '#fff' : '#aaa',
    textDecoration: current === lang ? 'underline' : 'none',
    padding: '0 4px',
  });

  return (
    <div style={{ textAlign: 'right', marginBottom: '8px' }}>
      <button style={btnStyle('en')} onClick={() => changeLanguage('en')}>EN</button>
      <span style={{ color: '#555' }}>|</span>
      <button style={btnStyle('it')} onClick={() => changeLanguage('it')}>IT</button>
    </div>
  );
};

export default LanguageSwitcher;
